import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { makeStyles } from '@material-ui/styles';
import IconChevronRightOutline from 'assets/img/IconChevronRightOutline';
import IconChevronLeftOutline from 'assets/img/IconChevronLeftOutline';
import { useTranslation } from 'react-i18next';

type CalendarHeaderProps = {
  onNavigate: (action: 'PREV' | 'NEXT' | 'TODAY') => void;
  label: string;
};

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
  },
  buttonWrapper: { display: 'flex', alignItems: 'center' },
  button: {
    width: '32px',
    height: '32px',
    display: 'flex',
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    background: grayColor[13],
    border: 'none',
    cursor: 'pointer',
    marginRight: '4px',
  },
  todayButton: {
    height: '32px',
    padding: '0 16px',
    borderRadius: '16px',
    background: grayColor[13],
    border: 'none',
    cursor: 'pointer',
    marginLeft: '8px',
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '0.02em',
  },
  label: {
    fontSize: '29px',
    fontWeight: '300',
    lineHeight: '125%',
    textTransform: 'capitalize',
  },
});

const CalendarHeader = ({ onNavigate, label }: CalendarHeaderProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const goToBack = () => onNavigate('PREV');
  const goToNext = () => onNavigate('NEXT');
  const goToToday = () => onNavigate('TODAY');

  return (
    <div className={classes.wrapper}>
      <div className={classes.buttonWrapper}>
        <button type="button" onClick={goToBack} className={classes.button}>
          <IconChevronLeftOutline />
        </button>
        <button type="button" onClick={goToNext} className={classes.button}>
          <IconChevronRightOutline />
        </button>
        <button
          type="button"
          onClick={goToToday}
          className={classes.todayButton}
        >
          {t('calendar.today')}
        </button>
      </div>
      <span className={classes.label}>{label}</span>
    </div>
  );
};

export default CalendarHeader;
